import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuardService } from './auth-guard.service';
import { AdalService } from './adal.service';
import { FrameRedirectComponent } from './frame-redirect/frame-redirect.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { routing } from './authentication.routing';
import { LoginErrorPageComponent } from './login-error-page/login-error-page.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    ButtonsModule,
    routing
],
  declarations: [
    FrameRedirectComponent,
    LoginComponent,    
    LogoutComponent, LoginErrorPageComponent
  ],
  exports: [

  ],
  providers: [
    AdalService, 
    AuthGuardService,
  ]

})
export class AuthenticationModule { }